import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import UIMessageProvider from '../../../components/common/UIMessageProvider';
import { FaTags, FaBriefcase, FaMoneyBillWave, FaTachometerAlt } from '../../../utils/iconUtils';

const AccountingLayout: React.FC = () => {
  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: FaTachometerAlt, path: '.', description: 'Accounting overview', end: true },
    { id: 'categories', label: 'Categories', icon: FaTags, path: 'categories', description: 'Manage accounting categories' },
    { id: 'vendors', label: 'Vendors', icon: FaBriefcase, path: 'vendors', description: 'Manage vendors and suppliers' },
    { id: 'management', label: 'Transactions', icon: FaMoneyBillWave, path: 'management', description: 'Transactions & records' },
  ];

  return (
    <div className="space-y-4">
      {/* Header (compact) */}
      <div className="bg-white rounded-xl shadow-soft p-3">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <div>
            <h1 className="text-lg font-semibold text-gray-800">
              Accounting <span className="text-gray-500 text-sm mt-0.5">(Manage categories, vendors & records)</span>
            </h1>
          </div>
        </div>

        {/* Compact Tab Navigation */}
        <div className="mt-3">
          <div className="flex gap-2 overflow-x-auto whitespace-nowrap py-1">
            {tabs.map((tab) => (
              <NavLink
                key={tab.id}
                to={tab.path}
                end={tab.end ?? false}
                className={({ isActive }) =>
                  `inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-all flex-shrink-0 ${
                    isActive
                      ? 'bg-primary-600 text-white shadow'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`
                }
              >
                <tab.icon className="h-4 w-4" />
                <div className="text-left">
                  <span className="font-medium text-sm leading-tight">{tab.label}</span>
                  <p className="text-xs opacity-70 hidden lg:block leading-tight">{tab.description}</p>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="min-h-[420px]">
        <UIMessageProvider>
          <Outlet />
        </UIMessageProvider>
      </div>
    </div>
  );
};

export default AccountingLayout;
